<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Contact Details">
										<FormRow>
												<FormLabel class="control-label">
													School Name
											</FormLabel>
										</FormRow>
										<FormRow>
												<!-- Remove event listeners -->
												<SchoolAutocomplete />
										</FormRow>
                    <ErrorLabel field="custom.schoolName" />
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>                       
                </FormSection>  
                <FormSection title="Amount">
                    <AmountSelectorSimple />                    
                    <ErrorLabel field="amount" />
                </FormSection>															
                <FormSection title="Donation Frequency">
                	<div class="frequency">
                    <PaymentOptions addSplit addMonthly monthlyText="Recurring Monthly Gift"/>
                  </div>
                    <!-- <DonationFrequency />  -->
									<TransactionFee /> 
                </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="">
										<FormRow>
												<FormLabel class="control-label">
													Notes
											</FormLabel>
										</FormRow>									
										<FormRow>
											<FormInput type="textarea" class="width-half" field="custom.Notes"/>                      
										</FormRow> 
								</FormSection>                
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false" />
                    </FormRow>             
                </FormSection>
                <PaymentButton showAmount btnText="PAY NOW"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
// Import the new component
import SchoolAutocomplete from '~/components/SchoolAutocomplete.vue'

export default defineComponent({
  components: {
    // Register the new component
    SchoolAutocomplete
  },
  setup(props) {
    const { form, setValue } = usePaymentForm()

    return {
      form,
      setValue
    }
  },
})
</script>
<style scoped lang="scss">

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.frequency{
	margin-top: 20px;
}
</style>

